module.exports = __webpack_public_path__ + "img/11.617ff7c8.webp";